<div class="container">
  <div class="insomnia_inner">
    <div class="row">
      <div class="col-md-4 col-md-push-8">
        <div class="side_title insomnia">
          <h1>
            Brought to you by:
          </h1>
        </div>

        <div class="insomnia_inner_sponsors ">
          <img width="150px" src="assets/img/insomnia/nvidia-logo.png" alt="">
          <img width="130px" src="assets/img/insomnia/msi-logo-w.png" alt="">
          <!--<img width="150px" src="assets/img/insomnia/adata-logo.png" alt="">-->
          <img width="100px" src="assets/img/insomnia/snd-logo.png" alt="">

        </div>


      </div>

      <div class="col-md-8 col-md-pull-4">

        <div class="side_title insomnia">
          <h1>
            Game Information
          </h1>
        </div>
        <p>
        <li>5v5 </li>
        <li>16 team online qualification before the event</li>
        <li>Pre-qualifications from the 4 - 10 October</li>
        <li>Single Elimination Bracket - BO1 (online Qualifications)</li>
        <li>Single Elimination Semi-finals & final - BO3</li>
        <li>4 teams to play at the event. Semi finals and finals on Saturday, 13 October</li>
        <li>All qualified teams will get free entry to the day of the event, plus 5 tickets for their fans</li>
        <li>All players must be living in Egypt</li>
        </p>

      </div>
    </div>

    <div class="row">
      <div class="col-md-4 col-md-push-8">
        <div class="side_title insomnia">
          <h1>
            Prize pool:
          </h1>
        </div>

        <p>

        <li>1st place: 10,000 EGP</li>
        <li>2nd place: 5,000 EGP</li>
        <li>3rd place: 3,000 EGP</li>
        <li>4th place: 2,000 EGP</li>

        </p>
      </div>

      <div class="col-md-8 col-md-pull-4">
        <div class="side_title insomnia">
          <h1>
            Timing
          </h1>
        </div>
        <p><b>Registration Starts: </b> 3 October</p>
        <p><b>Online Qualifications: </b> 7 October - 10 October</p>
        <p><strong>Semi-Finals & Finals</strong> Saturday, 13 October in the event</p>


      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="side_title insomnia">
          <h1>Registration</h1>
        </div>
        <p>
          <a href="https://gbarena.com/tournaments/xiIayn0J1Lg4/summary" target="_blank"
             class="go_button sm green square">
            Join Online Qualifications
          </a>
        </p>
        <p>We recommend you read over the terms and conditions which you can find <a href="https://www.insomniagamingegypt.com/termsandconditions/" target="_blank">here</a></p>
      </div>
    </div>


  </div>


</div>